import { useState } from 'react';
import './styles.sass';
import TruncateMarkup from 'react-truncate-markup';

interface IFieldItemProps {
    label: string;
    value: string;
    truncate?: {
        lines: number;
    };
}

export const FieldItem = ({ label, value, truncate }: IFieldItemProps) => {
    const [isTruncate, setIsTruncate] = useState<boolean>(!!truncate);

    const handleOnClickShowMore = () => setIsTruncate(!isTruncate);

    return (
        <div className="field-item">
            <span className="field-item__lable">{label}</span>
            <span className="field-item__value">
                {!!truncate && isTruncate ? (
                    <TruncateMarkup
                        ellipsis={
                            <>
                                ...
                                <button onClick={handleOnClickShowMore} className="field-item__more-text">
                                    еще
                                </button>
                            </>
                        }
                        lines={truncate.lines}
                    >
                        <span title={value}>{value}</span>
                    </TruncateMarkup>
                ) : (
                    value
                )}
            </span>
        </div>
    );
};
